import { Directive, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Directive()
export abstract class AbstractFormContainer implements OnInit {
  @Input() form: UntypedFormGroup;

  @Input() controlName = '';

  ngOnInit(): void {
    if (this.form) {
      this.addFormControls();
    }
  }

  abstract addFormControls(): void;
}
